class DistributorPriceVisualsDelegate {
    setAnomalyThresholdDraft(anomalyThresholdDraft) {
        this.setState({ anomalyThresholdDraft });
    }

    setSelectedProductIds(ids) {
        this.setState({ selectedProductIds: ids || [] });
    }

    setFocusedProductId(focusedProductId) {
        this.setState({ focusedProductId });
    }
}

export default DistributorPriceVisualsDelegate;
